module.exports = __webpack_public_path__ + "img/shop_small.e8f2e6e2.svg";